import React from 'react';
import { Box, Typography, Tooltip, IconButton } from '@mui/material';
import MusicNoteIcon from '@mui/icons-material/MusicNote'; // Icon for BG Music
import { useDropzone } from 'react-dropzone'; // For file uploads

const BackgroundMusicUpload = ({ onUpdateBackgroundMusic, assets }) => {
  // Handle BG Music upload
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'audio/*': ['.mp3', '.wav'], // Accept audio files
    },
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      const reader = new FileReader();
      reader.onload = () => {
        onUpdateBackgroundMusic(reader.result); // Pass the BG Music to the parent
      };
      reader.readAsDataURL(file);
    },
  });

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mt: 2, // Add margin to separate from other elements
      }}
    >
      <Tooltip title="Upload BG Music" arrow>
        <IconButton
          {...getRootProps()}
          sx={{
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            borderRadius: 1,
            cursor: 'pointer',
          }}
        >
          <input {...getInputProps()} />
          <MusicNoteIcon />
        </IconButton>
      </Tooltip>
      <Typography variant="body1">BG Music</Typography>
    </Box>
  );
};

export default BackgroundMusicUpload;